import { supabase } from '../../../src/lib/supabase';

export interface UcFilaVinculo {
  id: number;
  numero_uc: string;
  outro_numero_uc: string | null;
  nome_cliente: string | null;
  titular_fatura: string | null;
  cpf_cnpj_titular: string | null;
  cpf_cnpj_cliente: string | null;
  situacao: string | null;
  status_financeiro: string | null;
  cidade: string | null;
  estado: string | null;
  consumo_medio_kwh: number | null;
  grupo_tarifario: string | null;
  concessionaria: string | null;
  tipo_ligacao: string | null;
  num_medidor: string | null;
  modalidade_gd: string | null;
  cadastro_aprovado: boolean;
}

/**
 * Fila de vínculo com UG: mostra qualquer UC sem UG, inclusive Canceladas,
 * exceto quando a situação está em branco/nula E o cadastro ainda não foi
 * aprovado na análise cadastral (as duas juntas escondem a linha). Isso é
 * só a regra de VISIBILIDADE — elegibilidade pra vincular de fato é mais
 * estrita e é calculada no componente (cadastro aprovado + não Cancelada).
 */
const TAMANHO_PAGINA = 1000;

export async function listarUcsParaFilaVinculo(): Promise<UcFilaVinculo[]> {
  // Pagina obrigatoriamente: sem `.range` o PostgREST corta em 1000 linhas sem
  // erro nenhum, e a fila passou disso (1.346 UCs em 13/08/2026) — as UCs do
  // fim da ordem nunca apareciam pra ser vinculadas e ficavam fora do rateio.
  // O `id` entra junto no order pra a ordem ser total: com `nome_cliente`
  // sozinho, empate na virada de página duplica ou pula linha.
  const todas: UcFilaVinculo[] = [];
  for (let inicio = 0; ; inicio += TAMANHO_PAGINA) {
    const { data, error } = await supabase
      .from('unidades_consumidoras')
      .select(
        'id, numero_uc, outro_numero_uc, nome_cliente, titular_fatura, cpf_cnpj_titular, cpf_cnpj_cliente, situacao, status_financeiro, cidade, estado, consumo_medio_kwh, grupo_tarifario, concessionaria, tipo_ligacao, num_medidor, modalidade_gd, cadastro_aprovado'
      )
      .is('rateio_unidade_geradora_id', null)
      .or('situacao.not.is.null,cadastro_aprovado.eq.true')
      .order('nome_cliente')
      .order('id')
      .range(inicio, inicio + TAMANHO_PAGINA - 1);
    if (error) throw error;

    const lote = (data || []) as UcFilaVinculo[];
    todas.push(...lote);
    if (lote.length < TAMANHO_PAGINA) break;
  }
  return todas;
}

export async function vincularUcsAUg(ugId: string, ucIds: number[]): Promise<void> {
  const { error } = await supabase
    .from('unidades_consumidoras')
    .update({ rateio_unidade_geradora_id: ugId, rateio_vinculado_em: new Date().toISOString() })
    .in('id', ucIds);
  if (error) throw error;
}
